import utilActions from '@/api/actions';

const authorizePortcallberth = {
	id: 'authorizePortcallberth',
	selectionType: 'single',
	label: 'portcallberths.actions.authorizePortcallberth',
	functionality: 'AUTHORIZE_BERTH',
	checkAvailability: function (registries) {
		if (!canUserPerformAction(registries[0], this.$store)) {
			return false;
		}
		if (registries.length > 0) {
			return (registries && registries[0].berthingstatusid === 1) || (registries && registries[0].berthingstatusid === 6);
		}
		return false;
	},
	runAction: async function (action, model, registries) {
		const row = registries[0];

		const objectPk = utilActions.getPkFromModel(model, registries[0]);
		row.headerPk = objectPk;
		row.isAction = true;

		this.$puiEvents.$emit('pui-modalDialogForm-authorizePortcallberth-' + model.name + '-show', row);
	}
};

const initPortcallberth = {
	id: 'authorizePinitPortcallberthortcallberth',
	selectionType: 'single',
	label: 'portcallberths.actions.initPortcallberth',
	functionality: 'INITIATE_BERTHS',
	checkAvailability: function (registries) {
		if (!canUserPerformAction(registries[0], this.$store)) {
			return false;
		}
		if (registries.length > 0) {
			return registries && registries[0].berthingstatusid === 2;
		}
		return false;
	},
	runAction: async function (action, model, registries) {
		const row = registries[0];

		const objectPk = utilActions.getPkFromModel(model, registries[0]);
		row.headerPk = objectPk;
		row.isAction = true;

		this.$puiEvents.$emit('pui-modalDialogForm-initPortcallberth-' + model.name + '-show', row);
	}
};

const finishPortcallberth = {
	id: 'finishPortcallberth',
	selectionType: 'single',
	label: 'portcallberths.actions.finishPortcallberth',
	functionality: 'COMPLETE_BERTH',
	checkAvailability: function (registries) {
		if (!canUserPerformAction(registries[0], this.$store)) return false;
		if (!registries.length) return false;

		const reg = registries[0];
		const status = (reg.depharbourmasterstatus || '').toLowerCase().trim();

		const allowed = new Set(
			['Documentation validated', 'Cleared', 'დოკუმენტაცია დადასტურებულია', 'ნებართვა გაცემულია'].map((s) => s.toLowerCase())
		);

		return reg.berthingstatusid === 3 && allowed.has(status);
	},
	runAction: async function (action, model, registries) {
		const row = registries[0];
		const objectPk = utilActions.getPkFromModel(model, row);
		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-finishPortcallberth-' + model.name + '-show', row);
	}
};

const modifauthorizePB = {
	id: 'modifauthorizePB',
	selectionType: 'single',
	label: 'portcallberths.actions.modifauthorizePB',
	functionality: 'AUTHORIZE_BERTH',
	checkAvailability: function (registries) {
		if (!canUserPerformAction(registries[0], this.$store)) {
			return false;
		}
		if (registries.length > 0) {
			return registries && registries[0].berthingstatusid === 2;
		}
		return false;
	},
	runAction: async function (action, model, registries) {
		const row = registries[0];

		const objectPk = utilActions.getPkFromModel(model, registries[0]);
		row.headerPk = objectPk;
		row.isAction = true;

		this.$puiEvents.$emit('pui-modalDialogForm-modifauthorizePB-' + model.name + '-show', row);
	}
};

const modifinitPB = {
	id: 'modifinitPB',
	selectionType: 'single',
	label: 'portcallberths.actions.modifinitPB',
	functionality: 'AUTHORIZE_BERTH',
	checkAvailability: function (registries) {
		if (!canUserPerformAction(registries[0], this.$store)) {
			return false;
		}
		if (registries.length > 0) {
			return registries && registries[0].berthingstatusid === 3;
		}
		return false;
	},
	runAction: async function (action, model, registries) {
		const row = registries[0];

		const objectPk = utilActions.getPkFromModel(model, registries[0]);
		row.headerPk = objectPk;
		row.isAction = true;

		this.$puiEvents.$emit('pui-modalDialogForm-modifinitPB-' + model.name + '-show', row);
	}
};

const modifinishPB = {
	id: 'modifinitPB',
	selectionType: 'single',
	label: 'portcallberths.actions.modifinishPB',
	functionality: 'AUTHORIZE_BERTH',
	checkAvailability: function (registries) {
		if (!canUserPerformAction(registries[0], this.$store)) {
			return false;
		}
		if (registries.length > 0) {
			return registries && registries[0].berthingstatusid === 4;
		}
		return false;
	},
	runAction: async function (action, model, registries) {
		const row = registries[0];

		const objectPk = utilActions.getPkFromModel(model, registries[0]);
		row.headerPk = objectPk;
		row.isAction = true;

		this.$puiEvents.$emit('pui-modalDialogForm-modifinishPB-' + model.name + '-show', row);
	}
};

const insertETC = {
	id: 'insertETC',
	selectionType: 'single',
	label: 'portcallberths.actions.insertETC',
	functionality: 'INSERT_ETC',
	checkAvailability: function (registries) {
		if (!canUserPerformAction(registries[0], this.$store)) {
			return false;
		}
		if (registries.length > 0) {
			return registries && registries[0].berthingstatusid === 3;
		}
		return false;
	},
	runAction: async function (action, model, registries) {
		const row = registries[0];

		const objectPk = utilActions.getPkFromModel(model, registries[0]);
		row.headerPk = objectPk;
		row.isAction = true;

		// NMSWGMNT-63
		this.$puiEvents.$emit('pui-modalDialogForm-insertETC-' + model.name + '-show');
		this.$puiRequests.getRequest(
			'/portcalls/get',
			{
				portcallid: row.portcallid
			},
			(data) => {
				console.log('data', data);

				const modalData = {
					portcallberthid: row.portcallberthid,
					etc: row.etc
				};
				this.$puiEvents.$emit('pui-modalDialogForm-insertETC-' + model.name + '-show', modalData);
			}
		);
	}
};

const portFacilityTransfer = {
	id: 'portFacilityTransfer',
	selectionType: 'single',
	label: 'portcallberths.actions.portFacilityTransfer',
	functionality: 'PORT_FACILITY_TRANSFER',
	checkAvailability: function (registries) {
		if (registries.length > 0) {
			const row = registries[0];
			if (row.berthingstatusid === 1 || row.berthingstatusid === 2 || row.berthingstatusid === 3) {
				return true;
			}
			return false;
		}
		return false;
	},
	runAction: async function (action, model, registries) {
		const row = registries[0];

		const objectPk = utilActions.getPkFromModel(model, registries[0]);
		row.headerPk = objectPk;
		row.isAction = true;

		this.$puiEvents.$emit('pui-modalDialogForm-portFacilityTransfer-' + model.name + '-show', row);
	}
};

const rejectTransfer = {
	id: 'rejectTransfer',
	selectionType: 'single',
	label: 'portcallberths.actions.rejectTransfer',
	functionality: 'PORT_FACILITY_TRANSFER_CONFIRM_REJECT',
	checkAvailability: function (registries) {
		if (registries.length > 0) {
			const row = registries[0];
			if (row.berthingstatusid === 7) {
				return true;
			}
			return false;
		}
		return false;
	},
	runAction: async function (action, model, registries) {
		const row = {};
		const objectPk = utilActions.getPkFromModel(model, registries[0]);
		row.headerPk = objectPk;
		row.isAction = true;
		row.remarks = registries[0].remarks;
		row.pk = registries[0].portcallberthid;
		row.registries = registries[0];
		this.$puiEvents.$emit('pui-modalDialogForm-rejectTransfer-' + model.name + '-show', row);
	}
};

const confirmTransfer = {
	id: 'confirmTransfer',
	selectionType: 'single',
	label: 'portcallberths.actions.confirmTransfer',
	functionality: 'PORT_FACILITY_TRANSFER_CONFIRM_REJECT',
	checkAvailability: function (registries) {
		if (registries.length > 0) {
			const row = registries[0];
			if (row.berthingstatusid === 7) {
				return true;
			}
			return false;
		}
		return false;
	},
	runAction: async function (action, model, registries) {
		const row = {};
		const objectPk = utilActions.getPkFromModel(model, registries[0]);
		row.headerPk = objectPk;
		row.isAction = true;
		row.remarks = registries[0].remarks;
		row.pk = registries[0].portcallberthid;
		row.registries = registries[0];
		this.$puiEvents.$emit('pui-modalDialogForm-confirmTransfer-' + model.name + '-show', row);
	}
};

function canUserPerformAction(row, store) {
	const userCodes = store.getters.getSession.properties.GESTAUT_PROPERTIES_USER_TYPE_CODE_LIST;
	const relatedOrgs = store.getters.getSession.properties.GESTAUT_PROPERTIES_USER_RELATED_ORGS;
	const hasBeopandPodi = userCodes.includes('BEOP') && userCodes.includes('PODI');
	const berthoperatorid = `${row.berthoperatorid}`;
	const isRelatedOrg = relatedOrgs.some((orgId) => `${orgId}` === berthoperatorid);
	return !(hasBeopandPodi && !isRelatedOrg);
}

export default {
	gridactions: [
		authorizePortcallberth,
		initPortcallberth,
		finishPortcallberth,
		modifauthorizePB,
		modifinitPB,
		modifinishPB,
		insertETC,
		portFacilityTransfer,
		rejectTransfer,
		confirmTransfer
	],
	formactions: [
		authorizePortcallberth,
		initPortcallberth,
		finishPortcallberth,
		modifauthorizePB,
		modifinitPB,
		modifinishPB,
		insertETC,
		portFacilityTransfer,
		rejectTransfer,
		confirmTransfer
	]
};
